module.exports = __webpack_public_path__ + "static/f-icon3-0c208c1f807c7e75455d316b55c27c2f.svg";